import { render, staticRenderFns } from "./WWSLCPrint.vue?vue&type=template&id=958ffcd2&scoped=true&"
import script from "./WWSLCPrint.vue?vue&type=script&lang=js&"
export * from "./WWSLCPrint.vue?vue&type=script&lang=js&"
import style0 from "./WWSLCPrint.vue?vue&type=style&index=0&id=958ffcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958ffcd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
